import { Directive, HostListener, Input } from '@angular/core';
import { GTMServiceFactory } from '../factory/gtm-service.factory';

@Directive({
  selector: '[gtmTrackClick]',
  standalone: true,
})
export class GtmTrackClickDirective {
  @Input() gtmCategory: string = 'Button';
  @Input() gtmEvent: string = '';
  @Input() gtmEmail?: string;

  constructor(private gtmService: GTMServiceFactory) {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const config = {
      elementText: this.gtmEvent,
      category: this.gtmCategory,
      label: target.innerText,
      additionalData: this.gtmEmail ? { user_email: this.gtmEmail } : undefined,
    };
    this.gtmService.trackCustomEvent(this.gtmEvent, config);
  }
}
